export default __webpack_public_path__ + "static/media/EPS_1.7f9017cd.png";